import 'bootstrap/js/dist/carousel';

const cnCarousel = document.querySelector('.carousel');
//WCAG, tabindex and aria-hidden support
cnCarousel &&
    [cnCarousel].forEach((el) => {
        el.addEventListener('slide.bs.carousel', (event) => {
            event.relatedTarget.setAttribute('aria-hidden', false);
            event.relatedTarget.setAttribute('tabindex', '0');

            [...event.relatedTarget.parentNode.children]
                .filter((child) => child !== event.relatedTarget)
                .forEach((el) => {
                    el.setAttribute('aria-hidden', true);
                    el.setAttribute('tabindex', '-1');
                });
        });
    });
